import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import "./course-consent.page.scss";
import PLButton from "../../components/common/button";
import courseComander from "../../store/commanders/course.comander";
import navigationService from "../../services/navigation/navigation.service";
import { useTranslation } from "react-i18next";

const CourseConsentPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const userData = useSelector((state: any) => state.account.userData);
  const course = useSelector((state: any) => state.course);
  const [acceptedLiabilityNotice, setAcceptedLiabilityNotice] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const canAccessCourse = useMemo(() => {
    return !!userData?.valid_subscription || userData?.state === "AL";
  }, [userData?.state, userData?.valid_subscription]);

  useEffect(() => {
    if (!course?.data) {
      courseComander.cmd_get_course();
    }
  }, [course?.data]);

  useEffect(() => {
    if (!canAccessCourse) {
      navigationService.navigate("/payment?product=course");
      return;
    }

    if (course?.data?.courseConsentAccepted) {
      history.replace("/course");
    }
  }, [canAccessCourse, course?.data?.courseConsentAccepted, history]);

  const onContinue = async () => {
    setSubmitting(true);

    try {
      await courseComander.cmd_accept_course_consent();
      history.replace("/course");
    } finally {
      setSubmitting(false);
    }
  };

  if (!canAccessCourse) {
    return null;
  }

  const isReady = acceptedLiabilityNotice;

  return (
    <div className="course-consent-page">
      <div className="course-consent-card">
        <div className="course-consent-eyebrow">{t("courseConsent.eyebrow")}</div>
        <h1>{t("courseConsent.title")}</h1>
        <div className="course-consent-copy">
          <p>{t("courseConsent.paragraph1")}</p>
          <p>{t("courseConsent.paragraph2")}</p>
          <p>{t("courseConsent.paragraph3")}</p>
          <p>{t("courseConsent.paragraph4")}</p>
          <p>{t("courseConsent.paragraph5")}</p>
        </div>

        <div className="course-consent-options">
          <label className="course-consent-option">
            <input
              type="checkbox"
              checked={acceptedLiabilityNotice}
              onChange={(event) =>
                setAcceptedLiabilityNotice(event.target.checked)
              }
            />
            <span>
              {t("courseConsent.acknowledgement")}
            </span>
          </label>
        </div>

        <div className="course-consent-actions">
          <PLButton
            variant="primary"
            size="lg"
            onClick={onContinue}
            disabled={!isReady || submitting}
          >
            {submitting ? t("common.saving") : t("courseConsent.continue")}
          </PLButton>
        </div>
      </div>
    </div>
  );
};

export default CourseConsentPage;
